import { Skeleton } from "antd"
import { useProposalSettingsQuery } from "../../../domain/proposals/settings/proposalSettingsQueries"
import VSpace from "../../common/VSpace"
import PerVisitSettings from "./PerVisitSettings"
import QuotedAndTimeAndMaterialsSettings from "./QuotedAndTimeAndMaterialsSettings"
import TermsAndConditionsSettings from "./TermsAndConditionsSettings"
import GeneralSettings from "./GeneralSettings"
import FollowUpScheduleSettings from "./FollowUpScheduleSettings"
import ProposalLinks from "./ProposalLinks"
import { useEffect } from "react"

type Props = {
  onEditEmailTemplates: () => void
}

const Settings = ({ onEditEmailTemplates }: Props) => {
  const proposalSettingsQuery = useProposalSettingsQuery()

  useEffect(() => {
    const hash = window.location.hash
    if (proposalSettingsQuery.data && hash.includes("#terms-and-conditions-card")) {
      const anchorElement = document.getElementById("terms-and-conditions-card")
      if (anchorElement) {
        anchorElement.scrollIntoView({ behavior: "smooth" })
      }
    }
  }, [proposalSettingsQuery.data])

  if (proposalSettingsQuery.isLoading || !proposalSettingsQuery.data) {
    return <Skeleton active />
  }

  return <VSpace size="large">
    <GeneralSettings proposalSettings={proposalSettingsQuery.data} />
    <FollowUpScheduleSettings onEditEmailTemplates={onEditEmailTemplates} />
    <ProposalLinks />
    <QuotedAndTimeAndMaterialsSettings serverOptions={proposalSettingsQuery.data.defaultPaymentScheduleOptions} />
    <PerVisitSettings serverOptions={proposalSettingsQuery.data.defaultPaymentScheduleOptions} />
    <TermsAndConditionsSettings proposalSettings={proposalSettingsQuery.data} />
  </VSpace>
}

export default Settings
